<template>
  <div v-if="can" class="water-mark" :style="'background:url(' + can.toDataURL('image/png') + ') left top repeat'"></div>
</template>

<script>
export default {
  name: 'WaterMark',
  data() {
    return {
      can: null,
    }
  },
  methods: {
    initCan() {
      let user = JSON.parse(sessionStorage.getItem("user"))
      if(user) {
        let can = document.createElement('canvas')
        can.minWidth = 450
        can.height = 200
        let cans = can.getContext('2d')
        cans.rotate((-25 * Math.PI) / 180)
        cans.font = '15px Vedana'
        cans.fillStyle = 'rgba(125, 125, 125, .2)'
        cans.textAlign = 'left'
        cans.textBaseline = 'Middle'
        cans.fillText(`${user.userName} ${user.loginName}@正德信事务所`, -20, can.height)
        this.can = can
      }
    }
  }
}
</script>

<style>
.water-mark {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/waterMark/waterMark.vue